import http from 'services/http'
import _ from 'lodash'
import config from './organizations.json'

export const update = async (organizationId, data) => {
  const request = http.postAuthed(
    `/organizations/${organizationId}/update`,
    data,
  )
  const response = await request
  return response
}

const orgs = config.mapping

const mapByName = _.keyBy(orgs, 'name')
const mapById = _.keyBy(orgs, 'id')

const getRedirectsMap = (orgs) => {
  const map = {}
  orgs.forEach((org) => {
    ;(org.aliases || []).forEach((alias) => {
      map[alias] = org
    })
  })
  return map
}
const redirectsMap = getRedirectsMap(orgs)

// those are async functions as eventually they would retrieve this info from API

async function nameToId(name) {
  name = name.toLowerCase()
  const org = mapByName[name]
  if (org) {
    return org.id
  } else {
    return null
  }
}

async function idToName(id) {
  const org = mapById[id]
  if (org) {
    return org.name
  } else {
    return null
  }
}

async function shouldRedirect(name) {
  const org = redirectsMap[name]
  return !!org
}

async function getRedirectTarget(name) {
  const org = redirectsMap[name]
  if (org) {
    return org
  } else {
    return null
  }
}

export default {
  idToName,
  nameToId,

  getRedirectTarget,
  shouldRedirect,

  update,
}
